// iter-53n — Token-cost calculator. Every AI action in the editor has a
// rough output-token estimate so the user can see, BEFORE clicking, what
// the action will cost relative to their remaining budget.
//
// Estimates use the same 1.3 tokens-per-word multiplier the backend uses
// when recording usage (see routes_stream.py:_persist_generated_chapter →
// approx_tokens = words * 1.3). Input-side tokens (the prompt itself) are
// added as a small overhead per action.

const TOKENS_PER_WORD = 1.3;

const ACTION_OVERHEAD_TOKENS = {
  // tone-shift uses LAST 3 paragraphs as input; expected output ~220 words.
  toneShift: 1200,
  // continue takes last 3 paragraphs (~600 words context) + ~220 out.
  continue:  800,
  // full chapter draft: prior summary + system prompt input + full chapter out.
  chapter:   1500,
};

/** Estimated tokens needed to draft one chapter (the heaviest editor action). */
export function chapterTokens(wordsPerChapter = 2500) {
  return Math.round(wordsPerChapter * TOKENS_PER_WORD + ACTION_OVERHEAD_TOKENS.chapter);
}

/** Estimated tokens needed to "Continue" the prose (~220 words). */
export function continueTokens() {
  return Math.round(220 * TOKENS_PER_WORD + ACTION_OVERHEAD_TOKENS.continue);
}

/** Estimated tokens to rewrite the last passage in a different tone (~220 words). */
export function toneShiftTokens() {
  return Math.round(220 * TOKENS_PER_WORD + ACTION_OVERHEAD_TOKENS.toneShift);
}

/** Human-readable formatter that gracefully shortens large numbers. */
export function fmtTokens(n) {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  if (n >= 1_000)     return `${(n / 1_000).toFixed(1).replace(/\.0$/, '')}k`;
  return String(Math.round(n));
}

/** Remaining tokens for a {used, budget} bag. */
export function tokensRemaining(tokens) {
  return Math.max(0, (tokens?.budget || 0) - (tokens?.used || 0));
}

/**
 * Returns a status descriptor for the Buy-Tokens button. The button glows
 * GREEN when the user has comfortably more than enough tokens to draft a
 * full chapter; AMBER when they have enough for a chapter but the buffer
 * is thin; RED when even one chapter would exhaust the budget.
 */
export function buyTokensStatus(tokens, wordsPerChapter = 2500) {
  const remaining = tokensRemaining(tokens);
  const oneChapter = chapterTokens(wordsPerChapter);
  if (remaining >= oneChapter * 2)  return { level: 'ok',   remaining, oneChapter };
  if (remaining >= oneChapter)      return { level: 'low',  remaining, oneChapter };
  return                                   { level: 'empty', remaining, oneChapter };
}
